import TablePageSize from './TablePageSize';

interface Props {
  /** Zero-based current page. */
  page: number;
  totalPages: number;
  onPrev: () => void;
  onNext: () => void;
  pageSize: number;
  onPageSizeChange: (n: number) => void;
  /** Shows a subtle loading hint next to the page counter. */
  isFetching?: boolean;
}

/**
 * Shared pagination footer for every paginated table. Lays out as a single row on desktop
 * (prev/next on the left, page counter + page-size on the right) and reflows on mobile to two
 * tidy rows: Previous | Next, then the counter and page-size — instead of the cramped stack
 * the per-table markup produced before.
 */
export default function Pagination({
  page,
  totalPages,
  onPrev,
  onNext,
  pageSize,
  onPageSizeChange,
  isFetching,
}: Props) {
  return (
    <div className="pagination">
      <div className="pagination-nav">
        <button className="btn btn-ghost" disabled={page <= 0} onClick={onPrev}>
          ← Previous
        </button>
        <button className="btn btn-ghost" disabled={page >= totalPages - 1} onClick={onNext}>
          Next →
        </button>
      </div>
      <div className="pagination-meta">
        <span className="muted">
          Page {page + 1} of {totalPages}
          {isFetching ? ' …' : ''}
        </span>
        <TablePageSize value={pageSize} onChange={onPageSizeChange} />
      </div>
    </div>
  );
}
